var React = require('react');

function ArrowRight24x24 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Size=24x24, Hover=Off, Inverted=off","stroke":"currentColor","strokeWidth":"2"},[React.createElement("path",{"id":"Vector","d":"M12 22.5l10.5-10v-1L12 1.5","strokeMiterlimit":"10","strokeLinecap":"round","key":0}),React.createElement("path",{"id":"Vector_2","d":"M0 12h22","strokeLinejoin":"bevel","key":1})]));
}

ArrowRight24x24.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowRight24x24;

ArrowRight24x24.default = ArrowRight24x24;
